import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { FaceRecognitionResponse } from '../models/face.model';
import { Observable, Subject } from 'rxjs';
import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from '@angular/fire/firestore';

import { MessageService } from './messages.service';

export interface Item { 
  id: string,
  name: string,
  details: any;
  time: string;}

@Injectable()
export class FaceRecognitionService {
  private baseUrl = 'https://friendlyface.cognitiveservices.azure.com/face/v1.0';
  private itemsCollection: AngularFirestoreCollection<Item>;
  private attendanceCollection: AngularFirestoreCollection<Item>;
  items: Observable<Item[]>;
  attendance: Observable<Item[]>;
  response: any;
  message: any;
  identifiedPerson: string;
  personDbID: string;

  constructor(
    private httpClient: HttpClient,
    private afs: AngularFirestore,
    public afAuth: AngularFireAuth, // Inject Firestore service
    private messageService: MessageService
    ) {
      this.itemsCollection = afs.collection<Item>('logs/');
      this.items = this.itemsCollection.valueChanges();
  }

  // Scan Image Function
 // Credit: FabianGosebrink
  scanImage(subscriptionKey: string, base64Image: string) {
    const headers = this.getHeaders(subscriptionKey);
    const params = this.getParams();
    const blob = this.makeblob(base64Image);

    return this.httpClient.post<FaceRecognitionResponse>(
      environment.endpoint,
      blob,
      {
        params,
        headers,
      }
    );
  }

  // Make blob image Function
  // Credit: FabianGosebrink
  private makeblob(dataURL) {
    const BASE64_MARKER = ';base64,';
    const parts = dataURL.split(BASE64_MARKER);
    const contentType = parts[0].split(':')[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], { type: contentType });
  }

  // Get request headers Function
  private getHeaders(subscriptionKey: string) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/octet-stream');
    headers = headers.set('Ocp-Apim-Subscription-Key', subscriptionKey);
    return headers;
  }

  // Get Parameters Function
  private getParams() {
    const httpParams = new HttpParams()
      .set('returnFaceId', 'true')
      .set('returnFaceLandmarks', 'false')
      .set(
        'returnFaceAttributes',
        'age,gender,headPose,smile,facialHair,glasses,emotion,hair,makeup,occlusion,accessories,blur,exposure,noise'
      )
    return httpParams;
  }

  // Detect Api Method -  Return the response from - Detection
  detectApiMethod(response) {
    console.log(response);
    
    // For Each person in the response, display each persons faceID
    for (var index in response) {
      let personInfo = response[index];
      // POST request - Identify
      this.httpClient.post('https://friendlyface.cognitiveservices.azure.com/face/v1.0/identify',
      {
        "personGroupId": "ulsteruni",
        "faceIds": [personInfo.faceId],
        "maxNumOfCandidatesReturned": 1,
        "confidenceThreshold": 0.4
      },
      httpOptions
      )
      .subscribe(
        identity => {
          // console.log(identity);
          for (var candidate in identity){
            if (identity[candidate].candidates[candidate] == undefined){
              this.messageService.addError(("UNKNOWN PERSON DETECTED!!!!!"));
              this.addUnknownLog(personInfo);
            }else{
              return this.httpClient.get<any[]>(`${this.baseUrl}/persongroups/ulsteruni/persons/` + identity[candidate].candidates[candidate].personId, httpOptions)
              .subscribe((person: any) => {
                console.log(person);
                this.personDbID = person.userData;
                this.addLog(personInfo, person);
              });
          }}
        })
    }
  }

  // ADD LOG
  addLog(person, personIdent) {
    this.itemsCollection.add({
      id: this.afs.createId(),
      name: personIdent.name,
      details: person,
      time: new Date().toJSON("yyyy/MM/dd HH:mm"),
    });
    this.attendanceCollection = this.afs.collection<Item>('users/' + this.personDbID + '/attendance/');
    this.attendance = this.attendanceCollection.valueChanges();
    // Add to users Personal Log
    this.attendanceCollection.add({
      id: this.afs.createId(),
      name: personIdent.name,
      details: person,
      time: new Date().toJSON("yyyy/MM/dd HH:mm"),
    })
  }

  // Add unknown user log
  addUnknownLog(personInfo) {
    // console.log("Logging to Database");
    this.itemsCollection.add({
      id: this.afs.createId(),
      name: "",
      details: personInfo,
      time: new Date().toJSON("yyyy/MM/dd HH:mm"),
    })
  }

  // API REQUESTS

  addPersonGroup(id , name) {
  this.httpClient.put('https://friendlyface.cognitiveservices.azure.com/face/v1.0/persongroups/' + id ,
  {
    "name": name,
    "userData": "user-provided data",
    "recognitionModel": "recognition_01",
  },httpOptions
      )
      .subscribe(
        complete => this.messageService.add('Complete! Company Group - Added!'),
        err => this.messageService.add(err),
      );
  }

  addPerson(companyId, dbId ,name) {
    this.httpClient.post('https://friendlyface.cognitiveservices.azure.com/face/v1.0/persongroups/' + companyId + '/persons',
    {
      "name": name,
      "userData": dbId,
    },httpOptions
        )
        .subscribe(
          complete => this.messageService.add('Complete! Company Person - Added!'),
          err => this.messageService.add(err),
        );
    }

  addPersonFace(companyId, personId, url) {
    this.httpClient.post('https://friendlyface.cognitiveservices.azure.com/face/v1.0/persongroups/' + companyId + '/persons/' + personId + '/persistedfaces',
    {
      url: url
    },httpOptions
        )
        .subscribe(
          complete => this.messageService.add('Complete! Person Face - Added!'),
          err => this.messageService.add(err),
        );
    }

  deletePersonGroup(group) {
    console.log(group);
    if (confirm('Are you sure you would like to delete ' + group + ' ? This will remove all persons face data in this group.')) {
    return this.httpClient.delete('https://friendlyface.cognitiveservices.azure.com/face/v1.0/persongroups/' + group, httpOptions)
    .subscribe(
      complete => this.messageService.add('Complete! Company Group - Deleted!'),
      err => this.messageService.add(err),
    )
    }
  }

  deletePerson(companyId, personId) {
    console.log(companyId, personId);
    if (confirm('Are you sure you would like to delete ' + personId + ' ? This will remove all persons data in this group.')) {
    return this.httpClient.delete('https://friendlyface.cognitiveservices.azure.com/face/v1.0/persongroups/' + companyId + '/persons/' + personId, httpOptions)
    .subscribe(
      complete => this.messageService.add(JSON.stringify(`Complete! Company Group - Deleted!`)),
      err => this.messageService.add(err),
    )
    }
  }

  trainGroup(companyId) {
    this.httpClient.post('https://friendlyface.cognitiveservices.azure.com/face/v1.0/persongroups/'+ companyId +'/train',{}, httpOptions)
        .subscribe(
          complete => this.messageService.add(JSON.stringify('Training group ' + companyId + '!')),
          err => this.messageService.add(err),
        );
    }

  trainingStatus(companyId){
    this.httpClient.get('https://friendlyface.cognitiveservices.azure.com/face/v1.0/persongroups/'+ companyId +'/training', httpOptions)
    .subscribe(
      complete => this.messageService.add(JSON.stringify(complete)),
      err => this.messageService.add(err),
    )
  }

  getPersonGroups() {
    return this.httpClient.get<any[]>(`${this.baseUrl}/persongroups`, httpOptions);
  }

  getPersonsByGroup(id) {
    return this.httpClient.get<any[]>('https://friendlyface.cognitiveservices.azure.com/face/v1.0/persongroups/' + id + '/persons', httpOptions);    
  }

}

// private (non-exported)
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Ocp-Apim-Subscription-Key': environment.faceKey1
  })
};

